import { useEffect, useState } from 'react';
import { setupAPI } from '../api/client';

interface ManagedModeState {
  isManaged: boolean;
  whatsappConnected: boolean;
  loading: boolean;
}

export function useManagedMode(): ManagedModeState {
  const [state, setState] = useState<ManagedModeState>({
    isManaged: false,
    whatsappConnected: false,
    loading: true,
  });

  useEffect(() => {
    setupAPI.status()
      .then(s => {
        setState({
          isManaged: s.is_managed ?? false,
          whatsappConnected: s.whatsapp_connected,
          loading: false,
        });
      })
      .catch(() => {
        setState(prev => ({ ...prev, loading: false }));
      });
  }, []);

  return state;
}
